import styled, { css } from 'styled-components';
import Radio from '@carvana/showroom-forms/Radio';
import Input from '@carvana/showroom-forms/Input';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import Checkbox from '@carvana/showroom-forms/Checkbox';

const AutopayDetailsWrapper = styled.div`
  align-content: flex-start;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  margin: 0;
  color: #6d7184;

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    max-width: 1060px;
    min-height: 320px;
  }
`;

const AutopayDetailsFieldset = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
  padding: 0;
  justify-content: space-between;
`;

const AutopayConsentWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;

  a {
    color: ${(props) => props.theme.color.primary.v200};
    text-decoration: underline;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 665px;
  }
`;

const AutopayDueDateWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 24px;
`;

const AutopayAmountDueWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 100%;
  flex-wrap: nowrap;
  font-size: 16px;
  line-height: 24px;
  align-items: flex-start;

  @media (min-width: 376px) {
    max-width: 330px;
  }
`;

const AutopayDefaultAmountDueWrapper = styled.div`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0 10px 0;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;

  @media (min-width: 376px) {
    max-width: 330px;

    flex-wrap: nowrap;
  }
`;

const AutopayDetailsRadio = styled(Radio)`
  margin: 15px 0;

  // & Input[type='radio']:checked + div.radio__outline {
  //   border-color: #00619e;
  // }

  // & Input[type='radio']:checked + div.radio__outline > div.radio__dot {
  //   background-color: #00619e;
  // }
`;

const AutopayDetailsInput = styled(Input)`
  & Input {
    background: white;
    font-weight: normal;
  }

  & Label {
    color: #aab1c7;
  }

  & Input[disabled] {
    background: #fff;
  }

  & Input:not([disabled]) {
    background: #fff;
  }

  // & Input:focus {
  //   box-shadow: 0 0 0 1px white, 0 0 0 3px #00619e;
  // }

  // & Input:focus ~ label {
  //   top: -20px;
  //   color: #00619e;
  //   font-size: 10px;
  // }

  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  & input[type='number'] {
    -moz-appearance: textfield;
  }

  @media screen and (max-width: 767px) {
    & Input:not([disabled]) {
      font-size: 16px;
    }
  }
`;

const AutopayScheduleHeader = styled.h3`
  align-items: center;
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.color.primary.v600};
  padding: 30px 0 20px 0;
  margin: 0;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  width: 100%;
`;

const AutopayDefaultAmount = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0;
  //margin: 0 0 0 30%;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  // width: 100%;
`;

const AutopayButton = css`
  display: flex;
  padding: 0;
  width: 100%;
  min-width: 200px;
  min-height: 56px;
  font-size: 14px;
  margin-top: 32px;
  // margin-right: 14px;
`;

const AutopayNextButton = styled(PrimaryButton)`
  ${AutopayButton}

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    max-width: 250px;
    margin-right: 14px;
    text-align: center;
    // justify-content: flex-start;
  }
`;

const AutopayDetailsCheckbox = styled(Checkbox)`
  margin-top: 4px;
  margin-bottom: 40px;
  align-items: flex-start;
`;

const AutopayError = styled.div`
  color: red;
  margin-bottom: 15px;
  font-weight: bold;
`;

export {
  AutopayDetailsWrapper,
  AutopayDetailsRadio,
  AutopayDetailsInput,
  AutopayScheduleHeader,
  AutopayNextButton,
  AutopayDetailsCheckbox,
  AutopayConsentWrapper,
  AutopayDueDateWrapper,
  AutopayAmountDueWrapper,
  AutopayDefaultAmountDueWrapper,
  AutopayDefaultAmount,
  AutopayError,
  AutopayDetailsFieldset,
};
